import { ActionMap } from '@/store/store.interface';

import { JumplinkPayloadType, JumplinkType, JumplinkActions } from './jumplinks.interface';

export type JumplinkActionsType =
  ActionMap<JumplinkPayloadType>[keyof ActionMap<JumplinkPayloadType>];

export const JumplinkReducer = (state: JumplinkType[], action: JumplinkActionsType) => {
  switch (action.type) {
    case JumplinkActions.Add:
      return state.includes(action.payload)
        ? state
        : [
            ...state,
            {
              label: action.payload.label,
              href: action.payload.href,
            },
          ];
    case JumplinkActions.Clear:
      return [];
    default:
      return state;
  }
};
